import React from "react";

const STYLE_MAP = {
  info: {
    wrapper: "border-blue-200 bg-blue-50",
    eyebrow: "text-blue-700",
    title: "text-blue-950",
    body: "text-blue-900",
  },
  success: {
    wrapper: "border-emerald-200 bg-emerald-50",
    eyebrow: "text-emerald-700",
    title: "text-emerald-950",
    body: "text-emerald-900",
  },
  warning: {
    wrapper: "border-amber-200 bg-amber-50",
    eyebrow: "text-amber-700",
    title: "text-amber-950",
    body: "text-amber-900",
  },
  neutral: {
    wrapper: "border-slate-200 bg-slate-50",
    eyebrow: "text-slate-500",
    title: "text-slate-950",
    body: "text-slate-600",
  },
};

export default function SalesAffiliateStatusBanner({
  tone = "neutral",
  eyebrow,
  title,
  children,
}) {
  const styles = STYLE_MAP[tone] || STYLE_MAP.neutral;

  return (
    <section
      className={`rounded-3xl border px-6 py-6 ${styles.wrapper}`}
      aria-live="polite"
    >
      {eyebrow ? (
        <div
          className={`text-xs font-black uppercase tracking-[0.2em] ${styles.eyebrow}`}
        >
          {eyebrow}
        </div>
      ) : null}

      <h2 className={`mt-2 text-2xl font-black ${styles.title}`}>{title}</h2>

      {children ? (
        <div className={`mt-3 text-sm leading-6 ${styles.body}`}>
          {children}
        </div>
      ) : null}
    </section>
  );
}
